module.exports = __webpack_public_path__ + "img/plan_1.9c8298b8.png";